<template>
  <div v-if="countries.length">
    <div>
      <label class="form-label">{{ label || $t('countries') }}</label>
    </div>
    <div>
      <CheckboxGroup class="d-inline-block mr-4"
                     :fid="`${field}-all`"
                     :value="allSelected"
                     @input="toggleAll"
                     :label="$t('all')"/>
    </div>
    <CheckboxGroup v-for="c in countries"
                   class="d-inline-block mr-4"
                   :fid="`${field}-country-${c.id}`"
                   :key="`${field}-country-${c.id}`"
                   :checkboxvalue="c.id"
                   v-model="object[field]"
                   :label="c.title"/>
    <ValidationError class="mt-1" :validationId="field"/>
  </div>
</template>

<script setup>
import CheckboxGroup from "@/components/form/CheckboxGroup"
import ValidationError from "@/components/form/ValidationError"
import { onMounted, computed } from "vue"

const props = defineProps({
  object: {
    type: Object,
    required: true
  },
  field: {
    type: String,
    default: 'countries'
  },
  countries: {
    type: Array,
    default: () => []
  },
  label: {
    type: String,
    default: null
  }
})

onMounted(() => {
  if(props.object[props.field] === null || props.object[props.field] === undefined) {
    props.object[props.field] = []
  } else {
    props.object[props.field] = props.object[props.field].map(c => Number(c))
  }
})

const allSelected = computed(() => {
  if(!props.object[props.field] || !props.countries.length) return false
  return props.object[props.field].length === props.countries.length
})

const toggleAll = () => {
  if(allSelected.value) {
    props.object[props.field] = []
  } else {
    props.object[props.field] = props.countries.map(c => c.id)
  }
}
</script>
